import { useInfiniteQuery } from '@tanstack/react-query'
import {
  getUserVotes,
  UserVotesOrderBy,
  UserVotesOrderDirection,
} from '../api/userApi'
import { useAppContext } from '../contexts/App.context'
import { DEFAULT_PAGINATION } from '../api/boxApi'
import { useEffect } from 'react'

export interface UseUserVotesParams {
  orderBy?: UserVotesOrderBy
  orderDirection?: UserVotesOrderDirection
  limit?: number
}

export const useUserVotes = (params: UseUserVotesParams = {}) => {
  const { canFetchUserData } = useAppContext()
  const { orderBy, orderDirection, limit = DEFAULT_PAGINATION.limit } = params

  const query = useInfiniteQuery({
    queryKey: ['userVotes', orderBy, orderDirection, limit],
    queryFn: ({ pageParam = 1 }) =>
      getUserVotes({ orderBy, orderDirection, page: pageParam, limit }),
    getNextPageParam: lastPage => {
      if (lastPage.meta.totalPages <= lastPage.meta.page) {
        return undefined
      }
      return lastPage.meta.page + 1
    },
    initialPageParam: 1,
    enabled: canFetchUserData,
  })

  // Log when canFetchUserData changes to help debug
  useEffect(() => {
    console.log('useUserVotes: canFetchUserData changed to', canFetchUserData)
    if (canFetchUserData && !query.isFetching && !query.data) {
      console.log('useUserVotes: Triggering refetch')
      query.refetch()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canFetchUserData])

  return query
}
